import React, { FC } from 'react';

interface Props {
  title: string;
  className?: string;
}

export const SectionSubheader: FC<Props> = ({ title, className }) => (
  <span className={`leading-6 block text-accent-green font-bold ${className}`}>{title}</span>
);

export default SectionSubheader;
